<template>
  <ion-page>
    <ion-header>
      <app-toolbar
          :title="$t('interface.licences')"
          :settingsButton='false'
      />
    </ion-header>
    <ion-content>
      <ion-grid>
        <ion-row>
          <ion-col size="12">
            <ion-card>
              <ion-card-header>
                {{ $t('Cockpit') }}
              </ion-card-header>
              <ion-item lines="none">
                <ion-label>
                  {{ $t('interface.status') }}
                </ion-label>
                <ion-icon slot="end" color="success" :md="checkmark" :ios="checkmark"></ion-icon>
              </ion-item>
              <ion-item lines="none">
                <ion-label>
                  {{ $t('interface.expiring') }}
                  <p>In 2 Monaten</p>
                </ion-label>
                <ion-label slot="end">23.09.2022</ion-label>
              </ion-item>
            </ion-card>
          </ion-col>
          <ion-col size="12">
            <licence-activation />
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
    <app-footer/>
  </ion-page>
</template>

<script>
import {defineComponent} from "vue";
import {useStore} from "vuex";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonCard,
  IonCardHeader,
  IonItem,
  IonLabel,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon
} from '@ionic/vue';
import AppToolbar from "@/components/app-structure/AppToolbar.vue";
import LicenceActivation from "@/components/cards/LicenceActivation";
import AppFooter from "@/components/app-structure/AppFooter.vue";
import {checkmark, close} from "ionicons/icons";

export default defineComponent({
  setup () {
    const store = useStore();

    return { store, close, checkmark }
  },
  components: {
    AppFooter,
    IonContent,
    IonHeader,
    IonPage,
    IonCard,
    IonCardHeader,
    AppToolbar,
    IonItem,
    IonLabel,
    LicenceActivation,
    IonGrid,
    IonRow,
    IonCol,
    IonIcon,
  }
})
</script>

<style scoped lang="scss">
ion-item {
  --background: transparent !important;
}
</style>
